
import $ from 'jquery';

/**
 * COOKIE POPUP
 */
$(document).ready(function() {
    if (!navigator.cookieEnabled) {
        $(document).one('mousemove touchstart', function () {
            EN_KO.functions.open_popup( '#popup_cookie_hint' );
        });
    }
});
